var $ = global.jQuery = global.$;
var widgets = require('../lib/widgets');
var IconToggle = require('./IconToggle_PTS');
var _Base = require('./_Base');

var SELECTED_CLASS = 'is-selected';
var OPEN_CLASS = 'is-open';
var OPEN_ICON = 'icon--arrow-up';
var CLOSED_ICON = 'icon--arrow-down';

var FilterItem = _Base.extend({
  init: function() {
    var self = this;

    this.filter = this.$el.data('filter');
    this.value = -1;

    this.$content = this.$el.find('[data-sh-content]').eq(0);
    this.$contentClone = this.$content.clone();
    this.$count = this.$el.find('.count');
    this.$count = this.$count.length ? this.$count : this.$el.parents('[data-filter]').eq(0).find('.count');
    this.$icon = this.$el.find('.icon');
    this.$toggle = this.$el.find('[data-sh-toggle]').eq(0);
    this.siblings = this.getSiblings();
    this.children = this.getChildren();

    this.$combinedContent = this.$content.add(this.$contentClone);

    this.$filterToggles = this.$combinedContent.find('[data-toggle-filter=' + this.filter + ']');

    this.$filterToggles.on('click', function(event) {
      var clearSiblings = this.dataset.clearSiblings === '';
      event.preventDefault();
      self.toggleFilter(this.dataset.value, clearSiblings);
    });

    this.close();

    this.bindToggleEvents(this.$toggle);
  },
  setCount: function(count) {
    if (!this.$count) return false;
    if (!count) {
      this.$count.empty();
    } else {
      this.$count.text(count);
    }
  },
  getSiblings: function() {
    var siblings = [];
    this.$el.siblings().each(function() {
      if (this.dataset.filter) siblings.push(this.dataset.filter);
    });
    return siblings;
  },
  getChildren: function() {
    var children = [];
    this.$el.find('[data-filter]').each(function() {
      children.push(this.dataset.filter);
    });
    return children;
  },
  bindToggleEvents: function($toggle) {
    $toggle.on('click', this.toggle.bind(this));
    $toggle.attr('tabindex','0');
  },
  clear: function() {
    this.setValue(-1);
  },
  setValue: function(value) {
    this.value = value;
    this.setSelected(value);
    this.$el.trigger('Filter:Updated', [this.filter, this.value, this.children]);
  },
  setSelected: function(items) {
    var self = this;
    self.$filterToggles.removeClass(SELECTED_CLASS);
    if (items !== -1 && Array.isArray(items)) items.forEach(function(item) {
      self.$filterToggles.filter('[data-value=' + item + ']').addClass(SELECTED_CLASS);
    });
  },
  toggleFilter: function(value, clearSiblings) {
    var newFilters = this.value !== -1 ? this.value.slice() : [],
        currentIndex = newFilters.indexOf(value);

    if (currentIndex !== -1) {
      newFilters.splice(currentIndex, 1);
    } else {
      newFilters.push(value);
    }

    if (!newFilters.length) {
      newFilters = -1;
    } else if (clearSiblings) {
      newFilters = [value];
    }

    this.setValue(newFilters);
  },
  toggle: function(event) {
    event.preventDefault();
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  },
  open: function() {
    var self = this;
    this.$icon.addClass(OPEN_ICON);
    this.$icon.removeClass(CLOSED_ICON);
    this.$el.addClass(OPEN_CLASS);
    this.$toggle.addClass(OPEN_CLASS);
    this.$contentClone.show();
    this.$el.trigger('Close:Siblings', [this.siblings]);
    this.$el.trigger('Open:Children', [this.children]);
    var clearSiblings = this.$toggle.eq(0).data('clearSiblings') === '';
    if (clearSiblings) this.$el.trigger('Clear:Siblings', [this.siblings]);
    this.$content.velocity('slideDown', {
      duration: typeof animate === 'undefined' || animate ? 300 : 0,
      complete: function() {
        self.isOpen = true;
      }
    });
  },
  close: function() {
    var self = this;
    this.$icon.addClass(CLOSED_ICON);
    this.$icon.removeClass(OPEN_ICON);
    this.$el.removeClass(OPEN_CLASS);
    this.$toggle.removeClass(OPEN_CLASS);
    this.$contentClone.hide();
    this.$el.trigger('Close:Children', [this.children]);
    this.$content.velocity('slideUp', {
      complete: function() {
        self.isOpen = false;
      }
    });
  }
});

module.exports = FilterItem;



/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/widgets/FilterItem_PTS.js
 ** module id = 276
 ** module chunks = 1
 **/